export default [
  {
    path: '/:projectId/storage',
    component: () => import('@/views/storage/v2/Storage.vue'),
    noAnimation: true,
    children: [
      {
        path: 'buckets',
        component: () => import('@/views/storage/v2/buckets/Buckets.vue'),
        name: 'buckets',
        meta: {
          projectRequired: true,
          pageTitle: 'Buckets',
          rule: 'admin',
          navActiveLink: 'buckets',
          breadcrumb: [
            { text: 'Storage', disabled: true },
            { text: 'Buckets', active: true },
          ],
        },
      },
      {
        path: 'lens',
        component: () => import('@/views/storage/v2/lens/Lens.vue'),
        name: 'storage-lens',
        meta: {
          projectRequired: true,
          pageTitle: 'Storage Lens',
          rule: 'admin',
          navActiveLink: 'storage-lens',
          breadcrumb: [
            { text: 'Storage', disabled: true },
            { text: 'Lens', active: true },
          ],
        },
      },
      {
        path: 'keys',
        component: () => import('@/views/storage/v2/storage-keys/StorageKeys.vue'),
        name: 'storage-keys',
        meta: {
          projectRequired: true,
          pageTitle: 'Keys',
          rule: 'admin',
          navActiveLink: 'storage-keys',
          breadcrumb: [
            { text: 'Storage', disabled: true },
            { text: 'Keys', active: true },
          ],
        },
      },
    ],
  },
  {
    path: '/:projectId/buckets/start',
    component: () => import('@/views/storage/v2/StorageIntro.vue'),
    name: 'buckets-start',
    meta: {
      projectRequired: true,
      pageTitle: 'Storage',
      rule: 'admin',
      navActiveLink: 'buckets',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'Start Using Storage', active: true },
      ],
      redirectTo: 'buckets',
    },
  },
  {
    path: '/:projectId/storage/buckets/create/:accountId',
    component: () => import('@/views/storage/v2/buckets/NewBucket.vue'),
    name: 'create-bucket',
    meta: {
      projectRequired: true,
      pageTitle: 'Buckets',
      rule: 'admin',
      navActiveLink: 'buckets',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'Buckets', to: { name: 'buckets' } },
        { text: 'Create Bucket', active: true },
      ],
      redirectTo: 'buckets',
    },
  },
  {
    path: '/:projectId/storage/buckets/:accountId/:id/files',
    component: () => import('@/views/storage/v2/objects/files/Files.vue'),
    name: 'object-files',
    meta: {
      projectRequired: true,
      pageTitle: 'Objects',
      rule: 'admin',
      navActiveLink: 'buckets',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'Buckets', to: { name: 'buckets' } },
        { text: 'Files', active: true },
      ],
      redirectTo: 'buckets',
    },
  },
  {
    path: '/:projectId/storage/buckets/:accountId/:id/settings',
    component: () => import('@/views/storage/v2/objects/settings/Settings.vue'),
    name: 'bucket-settings',
    meta: {
      projectRequired: true,
      pageTitle: 'Objects',
      rule: 'admin',
      navActiveLink: 'buckets',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'Buckets', to: { name: 'buckets' } },
        { text: 'Settings', active: true },
      ],
      redirectTo: 'buckets',
    },
  },
  {
    path: '/:projectId/storage/buckets/:accountId/:id/add-lifecycle',
    component: () => import('@/views/storage/v2/objects/settings/lifecycle/Add.vue'),
    name: 'add-lifecycle',
    meta: {
      projectRequired: true,
      pageTitle: 'Add Lifecycle',
      rule: 'admin',
      navActiveLink: 'buckets',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'Buckets', to: { name: 'buckets' } },
        { text: 'Settings', to: { name: 'bucket-settings' } },
        { text: 'Add Lifecycle', active: true },
      ],
      redirectTo: 'buckets',
    },
  },
  {
    path: '/:projectId/storage/buckets/:accountId/:id/edit-lifecycle/:lifecycleId',
    component: () => import('@/views/storage/v2/objects/settings/lifecycle/Edit.vue'),
    name: 'edit-lifecycle',
    meta: {
      projectRequired: true,
      pageTitle: 'Edit Lifecycle',
      rule: 'admin',
      navActiveLink: 'buckets',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'Buckets', to: { name: 'buckets' } },
        { text: 'Settings', to: { name: 'bucket-settings' } },
        { text: 'Edit Lifecycle', active: true },
      ],
      redirectTo: 'buckets',
    },
  },

  // External Accounts
  {
    path: '/:projectId/storage/external-accounts',
    component: () => import('@/views/storage/v2/external-accounts/ExternalAccounts.vue'),
    name: 'external-accounts',
    meta: {
      projectRequired: true,
      pageTitle: 'External Accounts',
      rule: 'admin',
      navActiveLink: 'external-accounts',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'External Accounts', active: true },
      ],
    },
  },
  {
    path: '/:projectId/storage/external-accounts/add',
    component: () => import('@/views/storage/v2/external-accounts/Add.vue'),
    name: 'add-external-account',
    meta: {
      projectRequired: true,
      pageTitle: 'External Account',
      rule: 'admin',
      navActiveLink: 'external-accounts',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'External Account', to: { name: 'external-accounts' } },
        { text: 'Add External Account', active: true },
      ],
      redirectTo: 'external-accounts',
    },
  },
  {
    path: '/:projectId/storage/external-accounts/:id/edit',
    component: () => import('@/views/storage/v2/external-accounts/Edit.vue'),
    name: 'edit-external-account',
    meta: {
      projectRequired: true,
      pageTitle: 'Edit External Account',
      rule: 'admin',
      navActiveLink: 'external-accounts',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'External Account', to: { name: 'external-accounts' } },
        { text: 'Edit External Account', active: true },
      ],
      redirectTo: 'external-accounts',
    },
  },

  // Analytics
  {
    path: '/:projectId/storage/analytics',
    component: () => import('@/views/storage/v2/analytics/Analytics.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Storage Analytics',
      rule: 'admin',
      navActiveLink: 'storage-requests-analytics',
      breadcrumb: [
        { text: 'Storage', disabled: true },
        { text: 'Analytics', to: { name: 'storage-requests-analytics' }, active: true },
      ],
      redirectTo: 'storage-analytics',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/storage/v2/analytics/tabs/RequestsTab.vue'),
        name: 'storage-requests-analytics',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'storage-requests-analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'Storage', disabled: true },
            { text: 'Analytics', to: { name: 'storage-requests-analytics' }, active: true },
            { text: 'Requests', active: true },
          ],
        },
      },
      {
        path: 'traffic',
        component: () => import('@/views/storage/v2/analytics/tabs/TrafficTab.vue'),
        name: 'storage-traffic-analytics',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'storage-traffic-analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'Storage', disabled: true },
            { text: 'Analytics', to: { name: 'storage-requests-analytics' }, active: false },
            { text: 'Traffic', to: { name: 'storage-requests-analytics' }, active: true },
          ],
        },
      },
      {
        path: 'used-space',
        component: () => import('@/views/storage/v2/analytics/tabs/UsedSpaceTab.vue'),
        name: 'used-space-analytics',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'used-space-analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'Storage', disabled: true },
            { text: 'Analytics', to: { name: 'storage-requests-analytics' }, active: false },
            { text: 'Used Space', to: { name: 'used-space-analytics' }, active: true },
          ],
        },
      },
      {
        path: 'objects-count',
        component: () => import('@/views/storage/v2/analytics/tabs/ObjectsCountTab.vue'),
        name: 'objects-count-analytics',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'objects-count-analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'Storage', disabled: true },
            { text: 'Analytics', to: { name: 'storage-requests-analytics' }, active: false },
            { text: 'Used Space', to: { name: 'objects-count-analytics' }, active: true },
          ],
        },
      },
    ],
  },
]
